import React, { Component } from "react";
import "./App.css";
import BaseRoute from "routes/BaseRoute";

function App() {
  return (
    <div className="full_app_container">
      <BaseRoute />
    </div>
  );
}

export default App;
